// extracted by mini-css-extract-plugin
export var active = "_2f-d";
export var blink = "_2f-e";
export var container = "_2f-5";
export var controls = "_2f-0";
export var controlsRight = "_2f-1";
export var fakeCursor = "_2f-c";
export var hidden = "_2f-b";
export var quillContainerSmall = "_2f-7";
export var quillEditor = "_2f-6";
export var quillEditorSmall = "_2f-8";
export var quillFormatButtons = "_2f-a";
export var quillToolbar = "_2f-9";
export var removePadding = "_2f-2";
export var state = "_2f-3";
export var stateTitle = "_2f-4";